import React from 'react';
import useUser from '../hooks/useUser';
import OdcEditPage from './OdcEditPage';

const OdcEdit = ({ billIdFromProps, isDrawer, onSaveSuccess }) => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    return <OdcEditPage role={role} billIdFromProps={billIdFromProps} isDrawer={isDrawer} onSaveSuccess={onSaveSuccess} />;
};

export default OdcEdit;
